import { modifier } from 'ember-modifier';

export interface AditoolsRendererSignature {
  Element: Element;
  Args: {
    Positional: [inserted: (elem: Element) => void, destroying: (elem: Element) => void];
  };
}

const aditoolsRenderer = modifier<AditoolsRendererSignature>((element, [inserted, destroying]) => {
  inserted(element);
  return () => {
    if (destroying) {
      destroying(element);
    }
  };
});

export default aditoolsRenderer;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'aditools-renderer': typeof aditoolsRenderer;
  }
}
